export default __webpack_public_path__ + "static/media/next.f776c252.png";